import { render, staticRenderFns } from "./MaxLengthInput2.vue?vue&type=template&id=0a533b18&scoped=true"
import script from "./MaxLengthInput2.vue?vue&type=script&lang=js"
export * from "./MaxLengthInput2.vue?vue&type=script&lang=js"
import style0 from "./MaxLengthInput2.vue?vue&type=style&index=0&id=0a533b18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a533b18",
  null
  
)

export default component.exports